export enum PERMISSIONS {
    CREATE_DASHBOARD = 'CREATE_DASHBOARD',
    CREATE_ANALYSIS = 'CREATE_ANALYSIS',
    CREATE_REPORT_TEMPLATE = 'CREATE_REPORT_TEMPLATE',
    CREATE_REPORT_INSTANCE = 'CREATE_REPORT_INSTANCE',
    CREATE_AUTOMATION = 'CREATE_AUTOMATION',
}
export default class Permissions {
    constructor(
        readonly createDashboard: boolean,
        readonly createAnalysis: boolean,
        readonly createReportTemplate: boolean,
        readonly createReportInstance: boolean,
        readonly createAutomation: boolean
    ) {}
}
